import { render, staticRenderFns } from "./WordPlanList.vue?vue&type=template&id=b65e491c&scoped=true&"
import script from "./WordPlanList.vue?vue&type=script&lang=js&"
export * from "./WordPlanList.vue?vue&type=script&lang=js&"
import style0 from "./WordPlanList.vue?vue&type=style&index=0&id=b65e491c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65e491c",
  null
  
)

export default component.exports